<template>
    <div class='main'>
        <div class='content'>
            <h1 class='title is-4'>共通設定</h1>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>カード決済手数料</label>
                        <div class='question' data-tooltip='カード決済を利用する際の手数料を設定できます'>
                            <i class='fas fa-question-circle' aria-hidden='true'></i>
                        </div>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text" class='price-input' v-model='setting.cardFee'>
                            %
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>コンビニ決済手数料</label>
                        <div class='question' data-tooltip='コンビニ決済を利用する際の手数料を設定できます'>
                            <i class='fas fa-question-circle' aria-hidden='true'></i>
                        </div>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text" class='price-input' v-model='setting.conveniFee'>
                            円
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>ゆうパケット便最低送料</label>
                        <div class='question' data-tooltip='カメラマンが個別設定できるゆうパケット便送料の最低金額です'>
                            <i class='fas fa-question-circle' aria-hidden='true'></i>
                        </div>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text" class='price-input' v-model='setting.yuuPacketFee'>
                            円
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>システム利用料</label>
                        <div class='question' data-tooltip='店舗から受け取る手数料を設定できます'>
                            <i class='fas fa-question-circle' aria-hidden='true'></i>
                        </div>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text" class='price-input' v-model='setting.usageFee'>
                            %
                        </label>
                    </div>
                </div>
            </div>
            <div class='field is-horizontal'>
                <div class='field-label is-nomal'>
                    <div class='question-wrapper'>
                        <label class='label line-height-40'>自動補正手数料</label>
                        <div class='question' data-tooltip='カメラマンが自動補正を選択した際の画像1件あたりの手数料を設定できます'>
                            <i class='fas fa-question-circle' aria-hidden='true'></i>
                        </div>
                    </div>
                </div>
                <div class='field-body'>
                    <div class='field'>
                        <label class="line-height-40">
                            <input type="text" class='price-input' v-model='setting.correctionFee'>
                            円
                        </label>
                    </div>
                </div>
            </div>
            <button class='button is-info save' @click='save'>設定を保存</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Setting',
    components: {
    },
    data () {
        return {
            setting: {
                cardFee: 0,
                conveniFee: 0,
                correctionFee: 0,
                yuuPacketFee: 0,
                usageFee: 0
            }
        }
    },
    mounted () {
        const self = this

        self.axios.get(`${process.env.API_URL}/admin/setting`).then((res) => {
            const setting = res.data.setting

            if (setting) self.setting = setting
        }).catch((e) => {
            alert('サーバーに問題が発生しています')
        })
    },
    methods: {
        save () {
            const self = this

            self.axios.post(`${process.env.API_URL}/admin/setting`, {
                cardFee: self.setting.cardFee,
                conveniFee: self.setting.conveniFee,
                correctionFee: self.setting.correctionFee,
                yuuPacketFee: self.setting.yuuPacketFee,
                usageFee: self.setting.usageFee
            }).then((res) => {
                if (res.data.message === 'OK') {
                    alert('保存が完了しました')
                } else {
                    throw new Error()
                }
            }).catch((e) => {
                alert('サーバーに問題が発生しています')
            })
        }
    }
}
</script>

<style scoped>

.date {
    width: 200px;
}

.margin-l-20 {
    margin-left: 20px;
}

.line-height-40 {
    line-height: 40px;
}

.question-wrapper {
    display: flex;
}

.question {
    margin-left: 10px;
    height: 40px;
    cursor: pointer;
}

.label {
    width: 150px;
}

.fee-label {
    width: 50px;
}

.save {
    float: right;
    margin-top: 40px;
}

.line {
    margin-top: 30px;
    margin-bottom: 20px;
    border-bottom: 2px solid #f5f5f5;
}

.password {
    margin-top: 20px;
}

.fa-question-circle {
    height: 40px;
}

.size-titles {
    width: 320px;
    display: flex;
    height: 30px;
    margin-top: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.size-title, .size {
    width: 160px;
}

.content {
    padding: 25px;
    margin: auto;
    width: 780px;
}

.field-body {
    min-width: 780px;
}

.size-column {
    min-width: 160px;
}

.price-input {
    margin-top: 6px;
    height: 30px;
    width: 80px;
}

@media screen and (max-width: 768px) {

}

@media screen and (min-width: 768px) {
    .size {
        display: flex;
        margin-left: 210px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/pages/Setting.vue